import React from 'react';
import axios from 'axios';
import { Form, Select } from 'antd';

import apiPath from 'apiPath';

export default class DictionarySelect extends React.Component {
	state = {
		options: [],
		optionsLoaded: false
	}
	componentDidMount() {
		axios.get(apiPath + '/dictionary/' + this.props.code).then(result => {
			this.setState({ options: result.data.Dictionary.sort((a,b) => {
				return a.Name.localeCompare(b.Name);
			}), optionsLoaded: true });
		}).catch(error => {
			console.error(error);
		});
	}
	render() {
		const { getFieldDecorator, label, field, formItemLayout, disabled } = this.props;
		const prefix = this.props.prefix || '';
		let initialValue = this.props.initialValue;
		const excludedCodes = this.props.exclude || [];
		if (this.state.optionsLoaded) {
			let initialOption = this.state.options.find(option => option.Name === initialValue);
			if (initialOption) initialValue = initialOption.Code;
		}
		return (
			<Form.Item label={label} className={this.props.className} {...formItemLayout}>
				{typeof getFieldDecorator === 'function' && getFieldDecorator(prefix+field, {
					initialValue: initialValue,
					rules: (this.props.required) ? [{required: true, message: 'This field is required'}] : null
				})(
					<Select mode="combobox" allowClear
						placeholder={this.props.placeholder}
						onChange={this.props.onChange}
						onBlur={() => {
							if (!this.state.options.find(option => option.Code === this.props.form.getFieldValue(prefix+field))) {
								this.props.form.resetFields([prefix+field]);
							}
						}}
						disabled={disabled}
						filterOption={(inputValue, option) => {
							return option.props.title.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
						}}
						optionLabelProp="children">
						{this.state.options.filter(option =>
							excludedCodes.indexOf(option.Code) === -1
						).map(option => {
							return (
								<Select.Option
									key={option.Code}
									title={option.Name}>
									{(this.props.showAbbreviations)? option.Name+' ('+option.Code+')': option.Name}
								</Select.Option>
							);
						})}
					</Select>
				)}
			</Form.Item>
		);
	}
}



// WEBPACK FOOTER //
// ./portal-components/DictionarySelect/index.jsx